import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader } from '@/components/ui/loader';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Redirect to role-specific dashboard if trying to access /dashboard
  if (window.location.pathname === '/dashboard' && user.role) {
    const roleRoutes: Record<string, string> = {
      shipper: '/shipper/dashboard',
      transporter: '/transporter/dashboard',
      driver: '/driver/missions',
      admin: '/admin/dashboard',
    };
    const targetRoute = roleRoutes[user.role];
    if (targetRoute) {
      return <Navigate to={targetRoute} replace />;
    }
  }

  // Check if user has required role
  if (allowedRoles && user.role && !allowedRoles.includes(user.role)) {
    const roleRoutes: Record<string, string> = {
      shipper: '/shipper/dashboard',
      transporter: '/transporter/dashboard',
      driver: '/driver/missions',
      admin: '/admin/dashboard',
    };
    return <Navigate to={roleRoutes[user.role] || '/dashboard'} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
